export default __webpack_public_path__ + "static/media/2_0112.f0f03fd4.webp";